import { nullableString, } from '../validator.js';
export const importedTherapistsModuleUrl = import.meta.url;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function importedTherapistsSearchRequestSchema() {
    return {
        type: 'object',
        additionalProperties: false,
        properties: {
            displayName: nullableString(),
        },
    };
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function importedTherapistsSearchResponseSchema() {
    return {
        type: 'object',
        additionalProperties: false,
        properties: {
            status: {
                const: 'ok',
            },
            list: {
                type: 'array',
                items: {
                    type: 'object',
                    additionalProperties: false,
                    properties: {
                        id: {
                            type: 'string',
                            format: 'decimal',
                        },
                        displayName: {
                            type: 'string',
                        },
                        phone: {
                            type: ['string', 'null'],
                        },
                        country: {
                            type: 'string',
                        },
                        street: {
                            type: 'string',
                        },
                        postalCode: {
                            type: 'string',
                        },
                        city: {
                            type: 'string',
                        },
                    },
                    required: [
                        'id',
                        'displayName',
                        'phone',
                        'country',
                        'street',
                        'postalCode',
                        'city',
                    ],
                },
            },
        },
        required: [
            'status',
            'list',
        ],
    };
}
export async function importedTherapistsSearch(baseUrl, props) {
    const result = await fetch(`${baseUrl}/api/therapist/imported/search`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(props),
    });
    if (result.ok) {
        const data = await result.json();
        return data;
    }
    return {
        status: 'network error',
        httpStatus: result.status,
        message: await result.text(),
    };
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function importedTherapistsDeleteRequestSchema() {
    return {
        type: 'object',
        additionalProperties: false,
        properties: {
            id: {
                type: 'array',
                items: {
                    type: 'string',
                    format: 'decimal',
                },
                minItems: 1,
            },
        },
        required: [
            'id',
        ],
    };
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function importedTherapistsDeleteResponseSchema() {
    return {
        type: 'object',
        additionalProperties: false,
        properties: {
            status: {
                const: 'ok',
            },
        },
        required: [
            'status',
        ],
    };
}
export async function importedTherapistsDelete(baseUrl, props) {
    const result = await fetch(`${baseUrl}/api/therapist/imported/delete`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(props),
    });
    if (result.ok) {
        const data = await result.json();
        return data;
    }
    return {
        status: 'network error',
        httpStatus: result.status,
        message: await result.text(),
    };
}
//# sourceMappingURL=ImportedTherapistsApi.js.map